module.exports = __webpack_public_path__ + "static/entrance-door-4ba7304e69697fcd64a3941d87cc1c3b.png";